export default {
  tab: {
    contribution: 'Contribution',
    foreign: 'Foreign',
    proprietary: 'Proprietary',
    // proprietary: 'Local Institution',
    statistic: 'Statistic by Investor',
  },
  tooltipMatched: 'Matched: ',
  noData: 'No data available.',
  noDataSell: 'Sell --',
  noDataBuy: 'Buy --',
  tooltipDate: 'The data is calculated from %{from} to %{to}',
  tooltipToday: 'The data is caculated as of %{from}',
  tooltipInvestorToday:
    ' is caculated as of %{from}. Data is only for Hose exchange.',
  tooltipInvestorDate:
    ' is calculated from %{from} to %{to}. Data is only for Hose exchange.',
  tooltipHose: 'Statistic by Investors data',
  // proprietaryNotice: {
  //   title: 'Notice',
  //   content:
  //     'From March, 1st, 2022; Proprietary Data is replaced by Local Institutional Data <br/> (already including Proprietary Data).',
  // },
  // statInvestorNotice: {
  //   title: 'Notice',
  //   content:
  //     'From March, 1st, 2022; Proprietary Data is included in Local Institutional Data.',
  // },
};
